import { Component, HostListener, OnInit } from '@angular/core';
import { TranslationService } from '../../core/services/translation-service';
import { OFFICE365_PHONES } from '../../core/utils/phone-numbers';
import { NavigationService } from '../../core/services/navigation-service';
import { TextService } from '../../core/services/text-service';
import { Flow } from '../../core/utils/flow-utils';

interface LoginLink {
  label: string;
  href: string;
}

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.html',
  styleUrl: './top-menu.scss',
  standalone: false,
})
export class TopMenu implements OnInit {
  isMenuOpen = false;
  isLoginOpen = false;
  phone = OFFICE365_PHONES['en'];
  flow: Flow | undefined;

  readonly loginLinks: LoginLink[] = [
    { label: 'MyRackspace Portal', href: 'https://my.rackspace.com' },
    { label: 'Cloud Control Panel', href: 'https://mycloud.rackspace.com' },
    { label: 'Cloud Sites Control Panel', href: 'https://manage.rackspacecloud.com' },
    { label: 'Rackspace Webmail Login', href: 'https://apps.rackspace.com' },
    { label: 'Email Admin Login', href: 'https://cp.rackspace.com' },
  ];

  constructor(
    private i18n: TranslationService,
    private navService: NavigationService,
    public textService: TextService
  ) {}

  ngOnInit() {
    this.i18n.languageChanges$().subscribe((lang) => {
      this.phone = OFFICE365_PHONES[lang] || OFFICE365_PHONES['en'];
    });
  }

  get phoneHref(): string {
    return `tel:${this.phone.replace(/\s/g, '')}`;
  }

  toggleMenu() {
    this.flow = this.navService.getFlow();
    this.isMenuOpen = !this.isMenuOpen;
    this.isLoginOpen = false;

    const root = document.querySelector('app-top-menu');
    if (this.flow === 'apps' || this.flow === 'office365') {
      if (this.isMenuOpen) {
        root?.classList.remove('menu-open');
        root?.classList.add('menu-open-index');
      } else {
        root?.classList.add('menu-open');
        root?.classList.remove('menu-open-index');
      }
    } else {
      root?.classList.remove('menu-open');
    }
  }

  toggleLogin(event: Event) {
    event.stopPropagation();
    this.isLoginOpen = !this.isLoginOpen;
    if (this.isLoginOpen) {
      this.isMenuOpen = false;
    }
  }

  closeMenus() {
    this.isLoginOpen = false;
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.isLoginOpen = false;
  }
}
